import loadable from '@loadable/component';

export default {
    column: loadable(() => import('./ColumnTemplateLayout')),
    two_column: loadable(() => import('./TwoColumnTemplateLayout')),
    two_column_left: loadable(() => import('./TwoColumnLeftTemplateLayout')),
    two_column_right: loadable(() => import('./TwoColumnRightTemplateLayout')),
    funnel: loadable(() => import('./FunnelTemplateLayout')),
};
